import React from 'react';

const Error = () => {

  return (
    <>
        
        <section className="page-title">
            <div className="bg-layer" style={{backgroundImage: `url(assets/images/background/breadcrumb-1.jpg)`}}></div>
            <div className="auto-container">
                <div className="content-box">
                    <h1>Coming Soon</h1>
                    <ul className="bread-crumb clearfix">
                        <li><a href="/">Home</a></li>
                        <li>Error Page</li>
                    </ul>
                </div>
            </div>
        </section>
        
        <section className="error-section centred p_relative">
            <div className="auto-container">
                <div className="inner-box">
                    <h1>Coming Soon!</h1>
                    <h2>Stay Tuned</h2>
                    <p>The page you are looking for is coming soon.</p>
                    <a href="/" className="theme-btn btn-one">Back to homepage</a>
                </div>
            </div>
        </section>
    </>
    );
  }
  
  export default Error;